import { render, staticRenderFns } from "./custinforma.vue?vue&type=template&id=9cc68126&scoped=true"
import script from "./custinforma.vue?vue&type=script&lang=js"
export * from "./custinforma.vue?vue&type=script&lang=js"
import style0 from "./custinforma.vue?vue&type=style&index=0&id=9cc68126&prod&lang=scss&scoped=true"
import style1 from "./custinforma.vue?vue&type=style&index=1&id=9cc68126&prod&lang=scss"
import style2 from "./custinforma.vue?vue&type=style&index=2&id=9cc68126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc68126",
  null
  
)

export default component.exports